export default {"src":"/_next/static/media/play-store-icon.4fa7ac66.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};